import { render, staticRenderFns } from "./LineMultiColorHeaderSeparator.vue?vue&type=template&id=966234b8&scoped=true&lang=pug&"
import script from "./LineMultiColorHeaderSeparator.vue?vue&type=script&lang=js&"
export * from "./LineMultiColorHeaderSeparator.vue?vue&type=script&lang=js&"
import style0 from "./LineMultiColorHeaderSeparator.vue?vue&type=style&index=0&id=966234b8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966234b8",
  null
  
)

export default component.exports